import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BoostrapVue, { BootstrapVueIcons } from 'bootstrap-vue'
import AnalyticsPlugin from './plugins/analytics'
import SentryPlugin from './plugins/sentry'
import Branding from './plugins/branding'
import './assets/main.scss'
import { IS_DEV, ENV, env } from './config'
import HeaderImage from './components/HeaderImage.vue'
import RelatedImage from './components/RelatedImage.vue'
import ResourceAttribute from './components/ResourceAttribute.vue'
import messagesMixin from './mixins/messages'
import configMixin from './mixins/config'
import { moneyFormatFromPositiveInteger, creditsToCents, centsToCredits, joinFiltered } from '@/util'

if (!IS_DEV && !window.location.href.match(/^https:/)) {
    window.location.href = window.location.href.replace(/^http:/, 'https:')
}

Vue.config.productionTip = false

Vue.use(BoostrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(SentryPlugin, { router, env: ENV, dsn: env.SENTRY_DSN })
Vue.use(AnalyticsPlugin, { router, store, writeKey: env.ANALYTICS_WRITE_KEY })
Vue.use(Branding, { store })

Vue.mixin({
    components: {
        HeaderImage,
        RelatedImage,
        ResourceAttribute
    },
    methods: {
        centsToCredits,
        creditsToCents,
        joinFiltered,
        moneyFormat: moneyFormatFromPositiveInteger,
        currencySymbol() {
            return this.$store.getters.currencySymbol
        },
    },
    mixins: [
        messagesMixin,
        configMixin
    ]
})

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
